import React from 'react'
import Link from 'gatsby-link'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import R from 'ramda'
import classNames from 'classnames'

import { postEnhancer } from 'utils/enhancers'

import Difficulty from 'components/Difficulty'
import Title from 'components/Title'

const OffPistes = ({ siteTitle, posts }) => (
  <div className='max-width-2 mx-auto px2 mb3'>
    
    <Helmet title={`Off Piste Skiing in Val d’Isere | ${siteTitle}`} />
    
    <Title>
      Off Piste skiing in Val d’Isere
    </Title>
    
    <ul className='list-reset'>
      {posts.map(post => (
        <li 
          key={get(post, 'node.frontmatter.title')}
          className='mb2 md-mb3'
        > 
          <Link 
            to={post.node.frontmatter.path}
            className='flex items-center justify-between block black text-decoration-none line-height-1'
          >
            <p className='my0 h3 md-h2'>
              {post.node.frontmatter.title}
            </p>
            <Difficulty 
              frontmatter={post.node.frontmatter} 
            />
          </Link>
        </li>
      ))}
    </ul>
    
  </div>
)

OffPistes.propTypes = {
  route: React.PropTypes.object,
}

export default postEnhancer(OffPistes)

export const pageQuery = graphql`
  query OffPistesQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      filter: { frontmatter: { category: { eq: "off-piste" }}}
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      edges {
        node {
          frontmatter {
            path
            title
            difficulty
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/ski-area.js